import {isNumber} from 'lodash';
import React, {FC, useCallback, useState} from 'react';

import {isInteger} from '../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {OrderInputBox} from '../../../libs/shared/ui/src/components/boxedInputs/orderInputBox';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

interface DataFieldsTableOrderCellProps {
  order: number;
  onChange: (arg: number) => void;
}

/*
 * Component.
 */

export const DataFieldsTableOrderCell: FC<DataFieldsTableOrderCellProps> = ({
  order: initialOrder,
  onChange,
}) => {
  const [order, setOrder] = useState<number | ''>(initialOrder);

  const onSubmit = useCallback(
    (value: number | '') => {
      if (isInteger(value)) {
        onChange(value);
      }
    },
    [onChange],
  );

  return (
    <OrderInputBox
      min={1}
      noMargin
      size={VisualSizesEnum.SMALL}
      value={order}
      inputWidth={48}
      hasSmallArrows
      onChange={(value) => setOrder(value)}
      onBlur={() => onSubmit(order)}
      disableUpArrow={isNumber(order) && order <= 1}
      onUpArrow={() => {
        if (!isInteger(order)) {
          return;
        }
        onSubmit(order - 1);
      }}
      onDownArrow={() => {
        if (!isInteger(order)) {
          return;
        }
        onSubmit(order + 1);
      }}
    />
  );
};
